import CustomerReviewsPage from './CustomerReviewsPage';

export default CustomerReviewsPage;
